import { useRepositoriesStore } from '@/store/repositories'

export default async (settings: Record<string, any>) => {
  const repositoriesStore = useRepositoriesStore()

  if (settings.pinnedMenu) {
    settings.pinnedMenu = null
  }

  if (settings.sortedTabs) {
    await Promise.all(repositoriesStore.getList
      .map(repository =>
        repositoriesStore.updateSettings({ ui_settings: {
          ...repository.user_repo_settings.ui_settings,
          sortedTabs: settings.sortedTabs
        } }, repository.id),
      ))
    settings.sortedTabs = null
  }
}
